<div class="form-container">
  <div class="cardLayout">
    <ion-row>
      <ion-col size>
        <!-- <div class="formLabelSemiBoldfs16 mb-5">{{ data.operation === 'Add' ? 'Add' : 'Edit' }} Reimbursement</div> -->
        <div class="formLabelSemiBoldfs16 mb-5">Add Candidate </div>
      </ion-col>

      <ion-col size="auto" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>

    <!-- authority-form.component.html -->
    <form [formGroup]="condidateForm">
      <ion-row>
        <ion-col size="12" size-md="6" class="mt-10">

          <label class="formLabelSemiBoldfs16">Salutation <span class="red-cl">&nbsp;*</span></label>
          <mat-form-field class="w-100 mat-height40 mat-input-style mt-10">

            <mat-select placeholder="Select Salutation" formControlName="solutation">
              <mat-option value="Mr.">Mr.</mat-option>
              <mat-option value="Ms.">Ms.</mat-option>
              <mat-option value="Mrs.">Mrs.</mat-option>
              <mat-option value="Dr.">Dr.</mat-option>
            </mat-select>
            <mat-error *ngIf="hasError('solutation', 'required')">solutation is required</mat-error>
          </mat-form-field>

        </ion-col>
        <ion-col size="12" size-md="6" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">First Name<span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="firstName" placeholder="type here" />
            <mat-error *ngIf="hasError('firstName', 'required')">First name is required</mat-error>


            <mat-error *ngIf="condidateForm.get('firstName')?.hasError('maxlength')">
              Maximum 255 characters allowed
            </mat-error>
            <mat-error
              *ngIf="condidateForm.get('firstName')?.hasError('pattern') &&! condidateForm.get('firstName')?.hasError('maxlength')">
              Invalid characters used
            </mat-error>
            <mat-error *ngIf="
    condidateForm.get('firstName')?.hasError('whitespace') &&
    !condidateForm.get('firstName')?.hasError('required')
  ">
              First name cannot be just spaces
            </mat-error>
          </mat-form-field>
        </ion-col>


        <ion-col size="12" size-md="6" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">
            Last Name<span class="red-cl">&nbsp;*</span>
          </div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="lastName" placeholder="type here" />
            <mat-error *ngIf="hasError('lastName', 'required')">last name is required</mat-error>
            <mat-error *ngIf="condidateForm.get('lastName')?.hasError('maxlength')">
              Maximum 255 characters allowed
            </mat-error>
            <mat-error
              *ngIf="condidateForm.get('lastName')?.hasError('pattern') &&! condidateForm.get('lastName')?.hasError('maxlength')">
              Invalid characters used
            </mat-error>
            <mat-error *ngIf="
    condidateForm.get('lastName')?.hasError('whitespace') &&
    !condidateForm.get('lastName')?.hasError('required')
  ">
              First name cannot be just spaces
            </mat-error>
          </mat-form-field>
        </ion-col>

        <!-- Limit of Reimbursement -->



        <ion-col size="12" size-md="6" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Personal Email ID<span class="red-cl">*</span></div>
          <!-- <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="mail" placeholder="type here" />
            <mat-error *ngIf="hasError('mail', 'required')">mail is required</mat-error>
          </mat-form-field> -->
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="mail" placeholder="Type here" />
            <mat-error *ngIf="hasError('mail', 'required')">Mail is required</mat-error>
            <mat-error *ngIf="hasError('mail', 'pattern')">Enter a valid email address</mat-error>
          </mat-form-field>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12" class="text-right mt-10">
          <button type="button" class="add_btn fs-14 fs_12ForMobile mb-10" [style.background-color]="buttonColorName"
          [class.disabled]="condidateForm.invalid ||isSubmitting" (click)="savecandidatedata()">Send employment
          application form
          </button>
          <button class="back_btn fs-14 fs_12ForMobile mb-10 ml-10" (click)="cancelbutton()">Cancel</button>
        </ion-col>
      </ion-row>
    </form>

  </div>
</div>